"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueueScheduler = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _AsyncScheduler2 = require("./AsyncScheduler");

var QueueScheduler =
/*#__PURE__*/
function (_AsyncScheduler) {
  (0, _inherits2.default)(QueueScheduler, _AsyncScheduler);

  function QueueScheduler() {
    (0, _classCallCheck2.default)(this, QueueScheduler);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(QueueScheduler).apply(this, arguments));
  }

  return QueueScheduler;
}(_AsyncScheduler2.AsyncScheduler);

exports.QueueScheduler = QueueScheduler;